import styled from '@emotion/styled'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Hugeicon } from '../../../../icons/Hugeicon'
import { colors } from '../../../../styles/variables'

const DEBOUNCE_MS = 300

type Props = {
  value: string
  onChange: (value: string) => void
}

const EventSearchField: React.FC<Props> = ({ value, onChange }) => {
  const [localValue, setLocalValue] = useState(value)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value
      setLocalValue(newValue)
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => {
        try {
          onChange(newValue)
        } catch {
          /* parent handles errors */
        }
      }, DEBOUNCE_MS)
    },
    [onChange],
  )

  // Clean up pending debounce timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [])

  return (
    <SearchContainer>
      <SearchIcon name="search" size={16} />
      <SearchInput type="text" role="searchbox" placeholder="Search events..." value={localValue} onChange={handleChange} aria-label="Search events by title" />
    </SearchContainer>
  )
}

const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const SearchIcon = styled(Hugeicon)`
  position: absolute;
  left: 10px;
  width: 16px;
  height: 16px;
  color: ${colors.grey};
  pointer-events: none;
`

const SearchInput = styled.input`
  padding: 6px 12px 6px 32px;
  border: 1px solid ${colors.silver};
  border-radius: 6px;
  font-size: 14px;
  color: ${colors.darkgrey};
  background: white;
  width: 200px;

  &::placeholder {
    color: ${colors.grey};
  }

  &:focus {
    outline: none;
    border-color: ${colors.primaryColor};
  }
`

export default EventSearchField
